import { Button } from '@mui/material';
import React, { useEffect, useContext } from 'react';
import sun from '../../Images/sun.gif';
import './Darkmode.css';
import { Sun } from '../../SvgCollection';
import { ThemeContext } from './ThemeProvider';

function Darkmode() {
    const { isLightMode, handleDarkmode } = useContext(ThemeContext);

    useEffect(() => {
    }, [isLightMode]);

    return (
        <div className='darkmode'>
            <Button onClick={handleDarkmode}>
                {isLightMode ? <img src={sun} alt='sun' /> : <Sun />}
            </Button>
        </div>
    );
}

export default Darkmode;
